import { useMemo } from 'react';

import { getCustomFormattingContext, moneySum, priceFormatter } from '@dreryk/react-common';

import { Prices } from './totalPrice.types';

export const calculateTotalPrice = (...values: Prices): number => {
   return values.reduce<number>((currentPrice, value) => moneySum(currentPrice, value ?? 0), 0);
};

export const useTotalPrice = (prices: Prices): string | null => {
   return useMemo(() => {
      const calculatedTotalPrice = calculateTotalPrice(...prices);
      return priceFormatter(
         calculatedTotalPrice,
         getCustomFormattingContext({
            options: {
               currency: 'PLN',
               stripDecimalZeroes: true,
            },
         })
      );
   }, [prices]);
};
